import { useMemo } from "react";
import { toPackageType } from "@b2bportal/core-packages";
import { QueryParamType, useParseQueryParams } from "@b2bportal/core-utilities";
import { PACKAGES_QUERY_PARAM } from "@tenant/packages";

export const usePackageCarsShopPageRoute = () => {
  const queryParamDefinitions = {
    [PACKAGES_QUERY_PARAM.origin]: {
      type: QueryParamType.requiredString,
    },
    [PACKAGES_QUERY_PARAM.destination]: {
      type: QueryParamType.requiredString,
    },
    [PACKAGES_QUERY_PARAM.fromDate]: {
      type: QueryParamType.requiredDate,
    },
    [PACKAGES_QUERY_PARAM.untilDate]: {
      type: QueryParamType.requiredDate,
    },
    [PACKAGES_QUERY_PARAM.adults]: {
      type: QueryParamType.requiredNumber,
    },
    [PACKAGES_QUERY_PARAM.children]: {
      type: QueryParamType.optionalNumberArray,
    },
    [PACKAGES_QUERY_PARAM.roomsCount]: {
      type: QueryParamType.requiredNumber,
    },
    [PACKAGES_QUERY_PARAM.packageType]: {
      type: QueryParamType.optionalString,
    },
    [PACKAGES_QUERY_PARAM.driverAge]: {
      type: QueryParamType.optionalNumber,
    },
    [PACKAGES_QUERY_PARAM.packageToken]: {
      type: QueryParamType.requiredString,
    },
    [PACKAGES_QUERY_PARAM.infantsOnLap]: {
      type: QueryParamType.optionalNumber,
    },
    [PACKAGES_QUERY_PARAM.infantsInSeat]: {
      type: QueryParamType.optionalNumber,
    },
  };

  const params = useParseQueryParams(queryParamDefinitions);

  const {
    [PACKAGES_QUERY_PARAM.fromDate]: fromDate,
    [PACKAGES_QUERY_PARAM.untilDate]: untilDate,
    [PACKAGES_QUERY_PARAM.roomsCount]: roomCount,
    [PACKAGES_QUERY_PARAM.packageType]: packageType,
    [PACKAGES_QUERY_PARAM.driverAge]: driverAge,

    [PACKAGES_QUERY_PARAM.infantsOnLap]: infantsOnLap,

    [PACKAGES_QUERY_PARAM.infantsInSeat]: infantsInSeat,
    ...rest
  } = params;

  return useMemo(
    () => ({
      ...rest,
      fromDate,
      untilDate,
      roomCount,
      packageType: toPackageType(packageType),
      driverAge: driverAge ?? 25,
      infantsOnLap: infantsOnLap ?? undefined,
      infantsInSeat: infantsInSeat ?? undefined,
    }),
    [
      driverAge,
      fromDate,
      packageType,
      rest,
      roomCount,
      untilDate,
      infantsOnLap,
      infantsInSeat,
    ]
  );
};
